import React from 'react';
import { changeFilter } from '../../common/services/navigation';
import PropTypes from 'prop-types';

function TAPsDropdownItem({search, title, options, name}) {

	const change = e => {			
		changeFilter(search, name, e.target.value);
	};

    return (
        <div className="filter filter__dropdown">
            <label htmlFor={name} className="search__label visuallyhidden">{title}</label>
            <select className="filter__element" id={name} name={name} value={search[name]} onChange={change}>
                {<option value="">{title}</option>}

                {options.map((key, index) => (<option key={index} value={key}>{key}</option>))}		
                
                </select>
        </div>
    );

}

TAPsDropdownItem.propTypes = {
    search: PropTypes.object,
    title: PropTypes.string,
	options: PropTypes.array,
	name: PropTypes.string,
	istaxonomy: PropTypes.bool,
	settings: PropTypes.object
};

export default TAPsDropdownItem;